import React, { useContext } from 'react';
import './PrivacyPolicy.css';
import { ShopContext } from '../../../contexts/ShopContext';

const RefundPolicy = () => {
  const { shop } = useContext(ShopContext);
  return (
    <div className="contents">
      <div className="contents-wrapper">
        <div className="section-gap">
          <h1>Refund & Return Policy</h1>

          <h3>• Return Policy</h3>
          <div style={{ marginTop: '10px' }}>
            At {shop.name}, we prioritize delivering fresh, high-quality prepared food. Due to the perishable nature of
            our products, all sales are final, and we do not accept returns or exchanges. If there is an issue with your
            order, such as incorrect or damaged items, please contact us within 30 minutes of delivery. We will promptly
            address your concerns and provide a resolution.
          </div>

          <h3 style={{ marginTop: '20px' }}>• Refund Policy</h3>
          <div style={{ marginTop: '10px' }}>
            At {shop.name}, we do not offer refunds once an order is placed due to the perishable nature of our
            products.
          </div>
          <div style={{ marginTop: '10px' }}>
            Exceptional Cases: Refunds will only be considered in exceptional situations, such as incorrect or damaged
            orders. If approved, the refund will be credited within 4-7 business days to the original payment method.
          </div>
          <div style={{ marginTop: '10px' }}>
            For any concerns, please contact us within 30 minutes of receiving your order.
          </div>
          <div style={{ marginTop: '10px' }}>Thank you for your understanding and support!</div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
